import React from "react";
import { Spinner } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { FaCheckCircle } from "react-icons/fa";
import { FaTimesCircle } from "react-icons/fa";

const Card = styled.div`
  width: 100%;

  padding: 12px 16px;

  border: 1px solid #eaeaea;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .title-card {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
  }

  .status-loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    grid-gap: 8px;
  }

  .status-text {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
`;

interface CardDNSProps {
  title: string;
  isLoading: boolean;
  hasError: boolean;
}

export default function CardDNS({ title, isLoading, hasError }: CardDNSProps) {
  return (
    <Card>
      <div className="title-card">{title}</div>

      <div className="status-loading-wrapper">
        {isLoading ? (
          <Spinner
            size="sm"
            thickness="2px"
            speed="0.65s"
            emptyColor="gray.200"
            color="orange.500"
          />
        ) : hasError ? (
          <FaTimesCircle color="#C41700" size="16px" />
        ) : (
          <FaCheckCircle color="#75B85C" size="16px" />
        )}

        <div className="status-text">
          {isLoading ? "Verifying" : hasError ? "Failed" : "Verified"}
        </div>
      </div>
    </Card>
  );
}
